import React from "react";

import styled from "@emotion/styled";

import { responsive } from "../../utils/style";
import { css } from "@emotion/react";

const InformWarper = ({
  children,
  name,
  desc,
  icon,
  heroLabel,
  leftButton,
  rightButton,
  onLeftButtonClick,
  onRightButtonClick,
  onDescClick,
}) => {
  return (
    <Container>
      <Header>
        <InformName>{name}</InformName>
        <InformDesc>{desc}</InformDesc>
        {onDescClick && (
          <InformDetail onClick={onDescClick}>ดูรายละเอียด</InformDetail>
        )}
      </Header>
      <FormContainer>
        {children}
        <HeroIcon src={icon} />
        <HeroLabel>{heroLabel}</HeroLabel>
        <ButtonContainer>
          <HeroButton onClick={onLeftButtonClick}>
            <ButtonLabel>{leftButton}</ButtonLabel>
          </HeroButton>
          <HeroButton onClick={onRightButtonClick}>
            <ButtonLabel>{rightButton}</ButtonLabel>
          </HeroButton>
        </ButtonContainer>
      </FormContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 911px;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  ${responsive.tablet(css`
    max-width: unset;
  `)}
`;

const Header = styled.div`
  position: relative;
  display: flex;

  width: 100%;

  justify-content: space-between;
  align-items: center;

  ${responsive.tablet(css`
    width: calc(100% - 64px);
  `)}

  ${responsive.mobile(css`
    width: calc(100% - 32px);
  `)}
`;

const InformName = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;

  letter-spacing: -0.02em;

  color: #058459;

  ${responsive.mobile(css`
    font-size: 23px;
    line-height: 28px;
  `)}
`;

const InformDesc = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 23px;
  line-height: 28px;

  letter-spacing: -0.02em;

  color: #fc6b4b;

  text-decoration-line: ${(props) => (props.clickable ? "underline" : "none")};
  cursor: ${(props) => (props.clickable ? "pointer" : "unset")};

  ${responsive.mobile(css`
    font-size: 20px;
    line-height: 28px;
  `)}
`;

const InformDetail = styled(InformDesc)`
  position: absolute;
  top: 35px;
  right: 0;
  color: #4b5768;
  text-decoration-line: underline;
  cursor: pointer;
  font-size: 20px;
  line-height: 28px;

  ${responsive.mobile(css`
    top: 24px;
    font-size: 18px;
    line-height: 24px;
  `)}
`;

const FormContainer = styled.div`
  display: flex;

  width: 100%;

  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 40px 0 0;

  ${responsive.tablet(css`
    width: calc(100% - 64px);
  `)}

  ${responsive.mobile(css`
    width: calc(100% - 32px);
    margin: 24px 0 0;
  `)}
`;

const HeroIcon = styled.img`
  height: 262.94px;

  margin-top: 55px;

  ${responsive.tablet(css`
    height: 227.24px;

    margin-top: 50.24px;
  `)}

  ${responsive.mobile(css`
    height: 99px;

    margin-top: 17px;
  `)}
`;

const HeroLabel = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;

  text-align: center;
  letter-spacing: -0.02em;

  color: #fc6b4b;

  margin-top: 24px;

  ${responsive.mobile(css`
    font-size: 18px;
    line-height: 26px;

    margin-top: 16px;
  `)}
`;

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;

  justify-content: space-between;

  margin: 24px 0;

  ${responsive.mobile(css`
    margin: 16px 0;
  `)}
`;

const HeroButton = styled.div`
  width: 449.5px;
  height: 120px;
  background: #ffffff;

  border: 1px solid #fc6b4b;
  box-sizing: border-box;
  border-radius: 8px;

  display: flex;

  justify-content: center;
  align-items: center;

  cursor: pointer;

  ${responsive.tablet(css`
    width: calc(100% / 2 - 6px);
    height: 100px;
  `)}

  ${responsive.mobile(css`
    height: 60px;
  `)}
`;

const ButtonLabel = styled.span`
  font-family: "Noto Sans Thai", "Noto Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 23px;
  line-height: 28px;

  text-align: center;
  letter-spacing: -0.02em;

  color: #fc6b4b;

  ${responsive.mobile(css`
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    max-width: 132px;
  `)}
`;

export default InformWarper;
